module.exports = __webpack_public_path__ + "media/images/icon_work-fc556d18bd4eedefbbf4a842e16d5cba.svg";